export default {
  state: {
    pageData: null
  },
  mutations: {
    setPageInner(state, page) {
      state.pageData = page
    }
  },
  actions: {
    setPageData({ commit }, page) {
      commit('setPageInner', page)
    }
  }
}

